import { computed } from 'vue';
import { useUserStore } from '@/stores/user';

/**
 * Ongoing status of a self-registered customer's automatic feature setup, read straight off
 * `customer.registration_defaults_applied` - the same boolean the backend itself gates order
 * creation on, and which only ever reflects a `required_for_order_creation` feature. A
 * non-required feature (e.g. stats selection cards) failing never flips it, so it never shows
 * here either - no separate per-feature list to keep in sync on this side.
 *
 * Callable from both a component (reactive) and the router guard (read once per navigation): it
 * reads the store fresh every time, so there is nothing to keep in sync.
 */
export function useSelfRegistrationSetupStatus() {
  const userStore = useUserStore();

  // only self-registered customers get this status - Prospective sets up the rest manually
  const isEligible = computed(() => userStore.currentCustomer?.self_company_id != null);

  // null (not self-registered, or not yet processed) never blocks - only false does
  const isOrderCreationBlocked = computed(
    () => isEligible.value && userStore.currentCustomer?.registration_defaults_applied === false
  );

  const showSetupWarning = isOrderCreationBlocked;

  return { isEligible, showSetupWarning, isOrderCreationBlocked };
}
